/* eslint-disable no-undef */
import "./src/styles/index.scss";

import { ToggleWrapper } from "@lg-cfa/components";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { RecoilRoot } from "recoil";

import { FlowContext } from "./src/context/FlowContext";
import { useStateListener } from "./src/hooks";
import { RootLayout } from "./src/layouts/RootLayout";

window.dataLayer = window.dataLayer || [];

const HookLoader = () => {
    useStateListener();
    return null;
};

export const wrapRootElement = ({ element }) => {
    return (
        <HelmetProvider>
            <RecoilRoot>
                <ToggleWrapper>{element}</ToggleWrapper>
                <HookLoader />
            </RecoilRoot>
        </HelmetProvider>
    );
};

export const wrapPageElement = ({ element, props }) => {
    const newElement = React.cloneElement(
        element, // I18nextProvider
        element.props,
        React.cloneElement(
            element.props.children, // I18nextContext.Provider
            element.props.children.props,
            React.createElement(
                RootLayout,
                undefined,
                element.props.children.props.children,
            ),
        ),
    );

    return (
        <FlowContext.Provider value={props.pageContext.flow}>
            {newElement}
        </FlowContext.Provider>
    );
};
